namespace TabAurous.Sales {
    export interface DeliveryChallanLaborRow {
        TransLbrId?: number;
        TransItemId?: number;
        ItemTypeId?: number;
        AttributeId?: number;
        ProcessId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        CalcOnId?: number;
        LabourRate?: number;
        MarkUp?: number;
        LabourAmount?: number;
        DiscountPercent?: number;
        Discount?: number;
        WstPer?: number;
        WstWt?: number;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneColorId?: number;
        ShapeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        ProcessName?: string;
        Attribute?: string;
        IsCustomerItem?: boolean;
        CalculateTo?: number;
        CCLabourAmount?: number;
    }

    export namespace DeliveryChallanLaborRow {
        export const idProperty = 'TransLbrId';
        export const nameProperty = 'ProcessName';
        export const localTextPrefix = 'Sales.DeliveryChallanLabor';
        export const deletePermission = 'Sales:DeliveryChallan:Delete';
        export const insertPermission = 'Sales:DeliveryChallan:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:DeliveryChallan:Edit';

        export declare const enum Fields {
            TransLbrId = "TransLbrId",
            TransItemId = "TransItemId",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            ProcessId = "ProcessId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            CalcOnId = "CalcOnId",
            LabourRate = "LabourRate",
            MarkUp = "MarkUp",
            LabourAmount = "LabourAmount",
            DiscountPercent = "DiscountPercent",
            Discount = "Discount",
            WstPer = "WstPer",
            WstWt = "WstWt",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            StoneColorId = "StoneColorId",
            ShapeId = "ShapeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            ProcessName = "ProcessName",
            Attribute = "Attribute",
            IsCustomerItem = "IsCustomerItem",
            CalculateTo = "CalculateTo",
            CCLabourAmount = "CCLabourAmount"
        }
    }
}
